import { Controller } from "@hotwired/stimulus"
import {post} from "@rails/request.js";

// Connects to data-controller="select-all"
export default class extends Controller {

  static targets = ["selectAllCheck", "element", "action"]

  connect() {
    this.updateButtonState();
  }

  updateButtonState() {
    const checkedElements = this.enabledChecks().some(selectElement => selectElement.checked)
    this.selectAllCheckTarget.classList.toggle('fa-square', !checkedElements)
    this.selectAllCheckTarget.classList.toggle('fa-check-square', checkedElements)

    this.actionTargets.forEach(action => {
      if (!checkedElements) {
        action.setAttribute("disabled", "disabled");
      } else {
        action.removeAttribute("disabled")
      }
    })

  }

  onCheckboxChange() {
    this.updateButtonState();
  }

  selectAll(e) {
    e.preventDefault();
    e.stopPropagation()
    const hasCheckedElement = this.enabledChecks().some(element => element.checked);
    this.toggleCheck(hasCheckedElement)

    this.actionTargets.forEach(action => {
      if (hasCheckedElement) {
        action.setAttribute("disabled", "disabled");
      } else {
        action.removeAttribute("disabled")
      }
    })
  }

  selectNone(e) {
    e.preventDefault();
    e.stopPropagation()
    this.selectCheckFalse()

    const hasCheckedElement = this.enabledChecks().some(element => element.checked);
    if (hasCheckedElement === false) {
      this.selectAllCheckTarget.classList.add('fa-square')
      this.selectAllCheckTarget.classList.remove('fa-check-square')

      this.actionTargets.forEach(action => {
        action.setAttribute("disabled", "disabled");
      })
    }
  }

  toggleCheck(hasCheckedElement) {
    if (hasCheckedElement) {
      this.selectCheckFalse()
      this.selectAllCheckTarget.classList.add('fa-square')
      this.selectAllCheckTarget.classList.remove('fa-check-square')
    } else {
      this.selectCheckTrue()
      this.selectAllCheckTarget.classList.remove('fa-square')
      this.selectAllCheckTarget.classList.add('fa-check-square')
    }
  }

  selectCheckTrue() {
    this.enabledChecks().forEach(element => {
      element.checked = true;
    });
  }

  enabledChecks() {
    return this.elementTargets.filter(element => {
      return !element.disabled
    })
  }

  selectCheckFalse() {
    this.enabledChecks().forEach(element => {
      element.checked = false;
    });
  }

  selectElements() {
    return this.enabledChecks().filter(element => {
      return element.checked
    }).map(element => {
      return element.getAttribute("data-element-id")
    })
  }

  async destroySelected(e) {
    e.stopPropagation()
    const response = await post(e.target.dataset.url, {
      body: {elements_ids: this.selectElements()},
      responseKind: "turbo-stream"
    })
    if (response.ok)
      this.selectAllCheckTarget.classList.toggle('fa-square')
    this.actionTargets.forEach(action => {
      action.setAttribute("disabled", "disabled");
    })
  }

}
